module.exports = __webpack_public_path__ + "static/img/total_shop.67c9ac4.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/total_shop.png
// module id = XFxo
// module chunks = 0